import VueRouter from 'vue-router';

// import accountRoutes from './domains/account/routes';
import ordersRoutes from './domains/admin/orders/routes';
import productsRoutes from './domains/admin/products/routes';
import printersRoutes from './domains/admin/printers/routes';
import ruleBuilderRoutes from './domains/admin/rule-builder/routes';
import printerJobsRoutes from './domains/admin/printer-jobs/routes';
import customersRoutes from './domains/admin/customers/routes';
import invoicesRoutes from './domains/admin/invoices/routes';

const router = new VueRouter({
    mode: 'history',
    routes: [
        // ...accountRoutes,
        {
            path: '/',
            name: 'root',
            redirect: '/admin/orders/1',
        },
        ...ordersRoutes,
        ...productsRoutes,
        ...printersRoutes,
        ...ruleBuilderRoutes,
        ...printerJobsRoutes,
        ...customersRoutes,
        ...invoicesRoutes,
    ],
});

router.beforeEach((from, to, next) => {
    window.scrollTo(0, 0);

    next();
});

export default router;
